import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/personHierarchyNodes')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/personHierarchyNode' })
  },
})
